<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        PP/PD Monitoring
      </span>
    </div>
    <div class="wrapper-body">
      <a-card>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
            <a-button
              :class="getScreen ? 'margin-top' : ''"
              block
              :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
              @click="handleshowMore"
              >{{
                advancedsearch == "display:none" ? "More" : "Less"
              }}</a-button
            >
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Type</label>
              <a-select
                placeholder="Choose Transaction Type"
                v-model="filter.trans_type"
                class="width-full"
              >
                <a-select-option :key="0" value="all">All Transaction Type</a-select-option>
                <a-select-option :key="1" value="PP">PP</a-select-option>
                <a-select-option :key="1" value="SPPD">SPPD</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Directorate</label>
              <a-select
                placeholder="Choose Directorate"
                v-model="filter.directorate"
                class="width-full"
              >
                <a-select-option :key="0" value="all">All Directorate</a-select-option>
                <a-select-option
                  v-for="item in datasource.directorate"
                  :key="item.keys"
                  >{{ item.labels }}</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Cost Center</label>
              <a-select
                show-search
                placeholder="Choose Cost Center"
                v-model="filter.cost_center"
                class="width-full"
              >
                <a-select-option :key="0" value="all">All Cost Center</a-select-option>
                <a-select-option
                  v-for="item in datasource.cost_center"
                  :key="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>End User</label>
              <a-select
                show-search
                placeholder="Choose End User"
                v-model="filter.enduser"
                class="width-full"
              >
                <a-select-option :key="0" value="all">All End User</a-select-option>
                <a-select-option
                  v-for="item in datasource.enduser"
                  :key="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Create Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="filter.create_dt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
            <div class="m-form-item-wrapper">
              <label>Status</label>
              <a-select
                placeholder="Choose Status"
                v-model="filter.sts"
                class="width-full"
              >
                <a-select-option :key="0" value="all">All Status</a-select-option>
                <a-select-option :key="1" value="Urgensi">Urgensi</a-select-option>
                <a-select-option :key="1" value="Normal">Normal</a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </a-card>
      <a-card>
        <div v-if="selected_count>0" class="m-display-flex space-between">
          <div>&nbsp;</div>
          <div>
            <a-button type="primary" class="margin-bottom" @click="actionSelected" :disabled="action.loading">Selected : {{ selected_count }}</a-button>
          </div>
        </div>
        <a-config-provider :locale="getLocalConfigProvider()">
          <a-table bordered :columns="columns" :data-source="_list" size="small" 
            :pagination="false" 
            :rowKey="(record, index) => { return index; }" 
            :loading="table.loading"
            :scroll="{ x: 1800, y: '70vh' }"
          >
            <template slot="no" slot-scope="text, data, index">
              {{ index + 1 }}
            </template>
            <span slot="dt_tlc" slot-scope="item">
              {{ moment(item.tgl_buat).format(getDefaultDateFormat) }} / {{ item.pembuat }}
            </span>
            <span slot="notrans" slot-scope="item">
              <div><a @click="toManifest(item)"><b>{{ item.no_trans }}</b></a></div>
            </span>
            <span slot="eidr" slot-scope="item">
              <CurrencyJustified
                :currencyValue="item.currency"
                :valueNumber="item.kurs"
              />
            </span>
            <span slot="val" slot-scope="item">
              <CurrencyJustified
                :currencyValue="item.currency"
                :valueNumber="item.estimated_value"
              />
            </span>
            <span slot="eval" slot-scope="item">
              <CurrencyJustified
                :currencyValue="item.currency"
                :valueNumber="item.value_kurs"
              />
            </span>
            <span slot="status" slot-scope="item">
              <a-tag :color="item.selected_mon_sts=='Urgensi' ? 'red' : 'green'" class="margin-remove">
                <b style="text-transform: uppercase;">{{ item.selected_mon_sts ? item.selected_mon_sts : 'Normal' }}</b>
              </a-tag>
            </span>
            <template slot="customTitle">
              {{ "Action" }}&nbsp;
              <a-checkbox v-model="checkAllCollective" @change="onCheckAllChange">
              </a-checkbox>
            </template>
            <template slot="operation" slot-scope="index, item">
              <a-checkbox
                :value="item.check"
                :checked="item.check"
                :disabled="isDirektur && direktorat_user!=item.direktorat"
                @change="(e)=> { handleCheck(item,e) }"
              />
            </template>
          </a-table>
        </a-config-provider>
        <div class="margin-top">
          <a-row :gutter="[16,16]">
            <a-col v-for="(item, index) in board" :key="index" :xs="{ span: 24 }" :lg="{ span: 8 }">
              <a-card>
                <div><b>{{ item.directorate }}</b></div>
                <div class="m-display-flex space-between"><span>Value All IDR :</span><span>{{ formatRupiah(item.value_all_idr) }}</span></div>
                <div class="m-display-flex space-between"><span>Value Selected IDR :</span><span>{{ formatRupiah(item.value_selected_idr) }}</span></div>
                <div class="m-display-flex space-between"><span>Value unselected IDR :</span><span>{{ formatRupiah(item.value_unselected) }}</span></div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-card>
    </div>

    <a-modal v-model="action.visible" :title="'Option Action Selected : '+selected_count" :footer="false" @cancel="handleActionCancel">
      <div class="m-width-full">
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-button type="danger" class="m-width-full" @click="actionSelectedPost('Urgensi')" 
              :loading="action.loading_urgen" :disabled="action.loading_normal">Set to Urgent</a-button>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-button type="primary" class="m-width-full" @click="actionSelectedPost('Normal')" 
              :loading="action.loading_normal" :disabled="action.loading_urgen">Set to Normal</a-button>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "PPPDMonitoring",
  mixins: [GlobalMethod, CurrencyFormat],
  components: {},
  data() {
    return {
      search: "",
      advancedsearch: "display:none",
      filter:{
        trans_type: 'all',
        directorate: 'all',
        enduser: 'all',
        sts: 'all',
        create_dt: [null,null],
        cost_center: 'all',
      },
      table:{
        loading: false
      },
      datasource:{
        data: [],
        directorate: [],
        enduser: [],
      },
      checkAllCollective: false,
      action:{
        visible:false,
        loading_urgen: false,
        loading_normal: false
      },
      direktorat_user: null
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    columns() {
      const columns = [
          {
            title: "#",
            key: "no",
            align: "right",
            width: "50px",
            scopedSlots: { customRender: "no" },
          },
          {
            title: "Transaction Type",
            key: "trans_type",
            dataIndex: "trans_type",
            align: "center",
            width: "100px",
          },
          {
            title: "Direktorat",
            key: "directorat",
            dataIndex: "project_direktorat",
            align: "center",
            width: "150px",
          },
          {
            title: "Create Date / TLC",
            key: "dt_tlc",
            align: "center",
            width: "150px",
            scopedSlots: { customRender: "dt_tlc" },
          },
          {
            title: "No Transaction",
            key: "notrans",
            align: "center",
            width: "200px",
            scopedSlots: { customRender: "notrans" },
          },
          {
            title: "Description",
            key: "description",
            dataIndex: "deskripsi",
          },
          {
            title: "End User",
            key: "end_user",
            dataIndex: "end_user",
            align: "center",
            width: "75px",
          },
          {
            title: "Currency",
            key: "cur",
            dataIndex: "currency",
            align: "center",
            width: "75px",
          },
          {
            title: "Exchange IDR",
            key: "eidr",
            width: "120px",
            scopedSlots: { customRender: "eidr" },
          },
          {
            title: "Value",
            key: "val",
            width: "120px",
            scopedSlots: { customRender: "val" },
          },
          {
            title: "Exchange Value",
            key: "eval",
            width: "120px",
            scopedSlots: { customRender: "eval" },
          },
          {
            title: "Status",
            key: "status",
            align: "center",
            width: "100px",
            fixed: "right",
            scopedSlots: { customRender: "status" },
          },
          {
            slots: { title: 'customTitle' },
            dataIndex: "operation",
            scopedSlots: { customRender: "operation" },
            width: '75px',
            align: "center",
            fixed: "right",
          },
        ];
      return columns;
    },
    _list() {
      let output = this.datasource.data;

      if(this.filter.trans_type!='all'){
        output = output.filter(
          (obj) => (obj.trans_type && obj.trans_type.toLowerCase() == this.filter.trans_type.toLowerCase())
        )
      }

      if(this.filter.directorate!='all'){
        output = output.filter(
          (obj) => (obj.project_direktorat && obj.project_direktorat.toLowerCase() == this.filter.directorate.toLowerCase())
        )
      }

      if(this.filter.enduser!='all'){
        output = output.filter(
          (obj) => (obj.end_user && obj.end_user.toLowerCase() == this.filter.enduser.toLowerCase())
        )
      }

      if(this.filter.sts!='all'){
        output = output.filter(
          (obj) => ((obj.selected_mon_sts ? obj.selected_mon_sts : 'Normal').toLowerCase() == this.filter.sts.toLowerCase())
        )
      }

      if(this.filter.create_dt[0] && this.filter.create_dt[1]){
        output = output.filter(
          (obj) => (moment(obj.tgl_buat,'YYYY-MM-DD').format(this.getStandartFormatDate) >= this.filter.create_dt[0].format(this.getStandartFormatDate) &&
            moment(obj.tgl_buat,'YYYY-MM-DD').format(this.getStandartFormatDate) <= this.filter.create_dt[1].format(this.getStandartFormatDate))
        )
      }

      if(this.filter.cost_center!='all'){
        output = output.filter(
          (obj) => (obj.cost_center_kode && obj.cost_center_kode.toLowerCase() == this.filter.cost_center.toLowerCase())
        )
      }

      if(this.search)
        output = output.filter(
          (obj) =>
            (obj.trans_type && obj.trans_type.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.project_direktorat && obj.project_direktorat.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.no_trans && obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.tgl_buat && obj.tgl_buat.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.pembuat && obj.pembuat.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.deskripsi && obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.end_user && obj.end_user.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.currency && obj.currency.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        );
      return output;
    },
    selected_count(){
      return _.sumBy(this.datasource.data, function (val) {
          return val.check ? 1 : 0;
        }) 
    },
    board(){
      let result = []

      if(this.datasource.directorate.length>0)
      result.push({
        directorate: 'All Directorate',
        value_all_idr: 0,
        value_selected_idr: 0,
        value_unselected: 0,
      })

      let sum_per_directorate = 0;
      let sum_selected_directorate = 0;
      let sum_unselected_directorate = 0;
      this.datasource.directorate.forEach(element => {
        sum_per_directorate = _.sumBy(this.datasource.data, function (val) {
          return val.project_direktorat==element.keys ? val.estimated_value*val.kurs : 0;
        }) 
        sum_selected_directorate = _.sumBy(this.datasource.data, function (val) {
          return val.project_direktorat==element.keys && val.check ? val.estimated_value*val.kurs : 0;
        }) 

        sum_unselected_directorate = sum_per_directorate-sum_selected_directorate

        result[0].value_all_idr += sum_per_directorate
        result[0].value_selected_idr += sum_selected_directorate
        result[0].value_unselected += sum_unselected_directorate

        result.push({
          directorate: element.keys,
          value_all_idr: sum_per_directorate,
          value_selected_idr: sum_selected_directorate,
          value_unselected: sum_unselected_directorate
        })
      });

      return result
    },
    isDirektur(){
      return this.getAuth.posisi[0]=='Direktur'
    },
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    moment,
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    async fetchData() {
      this.table.loading = true;

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "pp-pd-monitoring",
        params: {
          private: this.$route.meta.private,
          limit : 25
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.table.loading = false;
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            let temp = response[0] ? response[0].data.data : [];
            temp.forEach(element => {
              element['check'] = false
            });
            this.datasource.data = temp
            this.datasource.directorate = response[0] ? response[0].data.directorate : [];

            this.direktorat_user = response[0] ? response[0].data.direktorat : null;
            if(this.direktorat_user){
              this.filter.directorate = this.direktorat_user
            }

            this.datasource.enduser = _.uniq(_.map(this.datasource.data, "end_user"));
            this.datasource.cost_center = _.uniq(_.map(this.datasource.data, "cost_center_kode"));
            this.table.loading = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onCheckAllChange(event){
      this._list.forEach((element) => {
        this.datasource.data[_.findIndex(this.datasource.data, (e) => {
          return e.id == element.id;
        }, 0)].check = event.target.checked;
      })
    },
    handleCheck(item, event){
      this.datasource.data[_.findIndex(this.datasource.data, (e) => {
          return e.id == item.id;
        }, 0)].check = event.target.checked;
    },
    actionSelected(){
      this.action.visible = true
    },
    handleActionCancel(){
      this.action.visible = false
    },
    actionSelectedPost(params){
      if(params=='Urgensi'){
        this.action.loading_urgen = true;
      }else{
        this.action.loading_normal = true;
      }

      let data_item = [];
      this._list.forEach((element) => {
        if(element.check) data_item.push({id:element.id, type:element.trans_type})
      })

      const payload = {
        data: data_item,
        status: params
      }
      this.asyncAxiosPost("pp-pd-monitoring/set_status", "json", this.getAuth, payload)
      .then(() => {
        this.action.loading_urgen = false;
        this.action.loading_normal = false;
        this.action.visible = false;
        this.table.loading = false;
        this.$router.go();
      })
      .catch((err) => {
        console.log(err);
        this.table.loading = false;
      });
    },
    toManifest(item){
      item.jenis_transaksi = item.trans_type;
      this.gotoManifestTrans(this, item, "_blank")
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.result {
  margin: @padding 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }
    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead > tr > th {
  text-align: center !important;
}

.tagsts{
  color: #1abc9c;
}

.ant-progress-outer {
  margin-right: calc(-2em - 5px)!important;
  padding-right: calc(2em + 5px)!important;
}
</style>
